import styled from 'styled-components'

export const Sheet = styled.div`
  background: #fff;
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
  padding: 24px 12px 0 12px;
  font-family: 'Open Sans', Arial, sans-serif;
  font-size: 14px;
  color: #111;
`

export const Title = styled.h1`
  font-size: 28px;
  font-weight: 700;
  color: #6b1f3a;
  margin-bottom: 0;
`

export const Hint = styled.p`
  font-size: 16px;
  margin-bottom: 12px;
`

export const SectionLabel = styled.div`
  font-weight: 700;
  font-size: 14px;
  margin: 16px 0 4px;
`

export const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border-top: 1px solid black;
  border-left: 1px solid black;
  margin-bottom: 0;
`

export const Td = styled.td<{ w?: string }>`
  border-right: 1px solid black;
  border-bottom: 1px solid black;
  padding: 4px 10px;
  font-size: 14px;
  vertical-align: middle;
  width: ${({ w }) => w || 'auto'};
`

export const TdArea = styled(Td)`
  vertical-align: top;
  padding-bottom: 12px;
`

export const TheadTd = styled.td`
  border-right: 1px solid black;
  border-bottom: 1px solid black;
  padding: 2px 10px;
  font-weight: 700;
  font-size: 14px;
  background: #d8d2c0;
  width: 50%;
`

export const FieldRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`

export const FieldLabel = styled.span`
  white-space: nowrap;
`

export const Input = styled.input`
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  border: none;
  outline: none;
  font-family: inherit;
  font-size: 14px;
  line-height: 1.4;
  background: transparent;
  padding: 0;
  margin-top: -2px;
`

export const InlineInput = styled(Input)`
  flex: 1;
  width: auto;
`

export const TextareaDiv = styled.div<{ minh?: string }>`
  width: 100%;
  font-family: inherit;
  font-size: 14px;
  background: transparent;
  min-height: ${({ minh }) => minh || '110px'};
  padding: 0;
  line-height: 1.6;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: pre-wrap;
`

export const AreaLabel = styled.div`
  margin-bottom: 6px;
`

export const IncidentTypeRow = styled.div`
  display: flex;
  align-items: center;
  gap: 100px;
`

export const CheckLabel = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-size: 14px;
`

export const Checkbox = styled.div<{ $checked?: boolean }>`
  width: 13px;
  height: 13px;
  border: 1px solid #555;
  background: #fff;
  flex-shrink: 0;
  position: relative;
`

export const SignatureNote = styled.p`
  font-size: 14px;
  margin: 8px 0 6px;
`

export const Footer = styled.div`
  margin-top: 16px;
  font-size: 16px;
`

export const FooterEmail = styled.p`
  margin-top: 4px;
`

export const FooterLink = styled.a`
  color: #6b1f3a;
`
